(function(angular){
    'use strict';

    angular.module('app').directive('apFacilityPortal', ApFacilityPortalDirective);

    function ApFacilityPortalDirective() {
        return {
            restrict: 'E',
            controller: [
                '$rootScope',
                '$scope',
                'CustomModuleRunService',
                ApFacilityPortalCtrl,
            ],
            templateUrl: '/app/views/apFacilityPortal.html',
        };
    }

    function ApFacilityPortalCtrl(
        $rootScope,
        $scope,
        CustomModuleRunService
    ) {
        var vm = {
            loadedAngular: false,
            
            isLoginView: isLoginView,
            onAngularInitialized: onAngularInitialized,
            shouldHideFooter: shouldHideFooter,
            shouldHideToolbar: shouldHideToolbar,
        };

        $scope.vm = vm;

        function isLoginView() {
            return $rootScope.loginView;
        }

        function onAngularInitialized() {
            CustomModuleRunService.run();
            vm.loadedAngular = true;
        }

        function shouldHideFooter() {
            return $rootScope.hideFooter;
        }

        function shouldHideToolbar() {
            return $rootScope.hideHeader;
        }
    }
})(window.angular);
